import { commonMenuItems } from "./common";
import defaultProfile from "./default";
import type { ConfigSection, GameProfile, Menu, ProfileCtx } from "./types";

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items.push(commonMenuItems.logs);
  return menu;
};

const configSections: ConfigSection[] = [
  { component: "ConfSection", props: { name: "basic" } },
  { component: "ConfSection", props: { name: "fortifications" } },
  { component: "ConfSection", props: { name: "timeweather" } },
  { component: "ConfSection", props: { name: "loot" } },
  { component: "ConfSection", props: { name: "vehicles" } },
  { component: "ConfSection", props: { name: "zombies" } },
  { component: "ConfSection", props: { name: "horde" } },
  { component: "ConfSection", props: { name: "animals" } },
  { component: "ConfSection", props: { name: "player" } },
];

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(),
  configSections,
});
